module.exports = __webpack_public_path__ + "static/media/230x0w.545831e1.webp";